import { createPortal } from 'react-dom';
import React, { Fragment, useState, useContext, useEffect, useRef } from 'react';
import {
  withStyles,
  Grid,
  Drawer,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import Close from '../../asset/img/icon_close.svg';
import Error from '../../asset/img/icon_error.svg';
import DataContext from '../data/DataContext';
import CheckOn from '../../asset/img/icon_checkbox_on.svg';
import CheckOff from '../../asset/img/icon_checkbox_off.svg';
import { useForm } from 'react-hook-form';
import Terms3 from './Terms3';
const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  drawerFrame: {
    borderRadius: '0',
    borderBottomRightRadius: '0',
    borderBottomLeftRadius: '0',
    height: '100%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
    background: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dividerTitle: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 0.875rem 1.2188rem 0.875rem',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '0.0625rem 0rem',
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'none',
    background: 'none',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
      cursor: 'pointer',
    },
  },
  closeContainer: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  componentWrapper: {
    overflowY: 'auto',
    paddingTop: '4.375rem',
  },
  drawerHeaderClose: {
    position: 'fixed',
    height: '4.375rem',
    background: '#fff',
    width: '100%',
    zIndex: '1',
  },
  loading: {
    zIndex: '2000',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffffd9',
  },
  loadComplete: {
    display: 'none',
  },
  dialogRoot: {
    borderRadius: '0.625rem',
    width: '90%',
    maxWidth: '37.5rem',
  },
  dialogContent: {
    fontFamily: 'inherit',
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    padding: '2.5rem 1.25rem 0.9375rem !important',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'cneter',
    padding: '0.9375rem',
    '& button': {
      height: '3.125rem',
      width: '50%',
      borderRadius: '0.375rem',
      border: 'solid 0.0625rem #ea1917', //"solid 0.0625rem #da0f47",
      fontFamily: 'inherit',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.43',
      letterSpacing: 'normal',
      textAlign: 'center',
    },
  },
  dialogFooterBtnLeft: {
    background: '#fff',
    color: '#000',
    border: 'solid 0.0625rem #ddd !important',
  },
  dialogFooterBtnRight: {
    background: '#ea1917', //"#da0f47",
    color: '#fff',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 0.875rem 1rem',
    marginTop: '1rem',
    placeContent: 'center',
    borderTop: '0.0625rem solid #ddd',
  },
  modalButtonLeft: {
    paddingRight: '0.25rem',
  },
  modalButtonRight: {
    paddingLeft: '0.25rem',
  },
  modalCancel: {
    width: '100%',
    height: '3.125rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #ea1917', //"solid 0.0625rem #da0f47",
    backgroundColor: '#fff',
    // margin: "0rem 0.25rem",
    fontFamily: 'NotoSansKR',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#ea1917', //"#da0f47",
  },
  modalButton: {
    width: '100%',
    height: '3.125rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #ddd',
    backgroundColor: '#fff',
    // margin: "0rem 0.25rem",
    fontFamily: 'NotoSansKR',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0rem',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0rem',
    fontWeight: 'bold',
  },
  modalConfirmDisable: {
    border: '0',
    backgroundColor: '#999',
    color: '#bbb',
  },
  modalGridContainer: {},
  modalGridItemLabel: {
    padding: '0.75rem 1rem 0rem 1rem',
  },
  modalGridItemLabelFirst: {
    padding: '0.25rem 1rem 0rem 1rem',
  },
  modalGridItem: {
    padding: '0.75rem 1rem',
  },
  modalLabel: {
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',

    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', //"#da0f47"
    },
  },
  modalField: {
    '& input': {
      borderRadius: '0.375rem',
      width: '100%',
      height: '2.875rem',
      border: 'solid 0.0625rem #929292',
      padding: '0.8125rem 1rem',
    },
  },
  modalPlainBtn: {
    minHeight: '2.875rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0rem',
    paddingRight: '0.5rem',
  },
  modalInnerItemLast: {
    paddingRight: '0rem',
  },
  infoIcon: {
    width: '1rem',
    height: '1rem',
  },
  textareaField: {
    position: 'relative',
  },
  textarea: {
    width: '100%',
    height: '9.375rem',
    borderRadius: '0.375rem',
    background: '#fff',
    font: 'inherit',
    fontSize: '0.875rem',
    padding: '0.8125rem 1rem 2.1875rem',
  },
  textCount: {
    font: 'inherit',
    fontSize: '0.75rem',
    letterSpacing: 'normal',
    position: 'absolute',
    bottom: '0.875rem',
    right: '1rem',
  },
  nextLine: {
    paddingBottom: 0,
  },
  disabled: {
    background: '#ededed',
    border: '0rem !important',
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: '#000',
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  termTextArea: {
    height: '7.5rem',
    border: '0.0625rem solid #929292',
    borderRadius: '0.375rem 0.375rem 0 0',
    fontSize: theme.font.size12,
    padding: '1rem',
    lineHeight: '1.72',
    '& .termsDl': {
      height: '5.45rem',
      overflow: 'auto',
    },
    '& dl': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& dd': {
      marginInlineStart: '0rem',
    },
    '& ol': {
      listStyleType: 'none',
      paddingInlineStart: '0rem',
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& li': {
      listStyleType: 'none',
      paddingInlineStart: '0',
    },
    '& ol.termsOl>li': {
      paddingBlockStart: '0.5rem',
      '&:first-child': {
        paddingBlockStart: '0rem',
      },
    },
    '& ul': {
      paddingInlineStart: '0.625rem',
    },
    '& dt': {
      fontWeight: 'bold',
    },
    '& .layerPopupTop': {
      display: 'none',
    },
    '& .type2.contentsLyrPopx': {
      display: 'none',
    },
    '& .layerTopBtn': {
      display: 'none',
    },
    '& .termsDl .blind': {
      display: 'none',
    },
    '& .layerPopupBottom': {
      display: 'none',
    },
  },
  termTextContent: {
    height: '5.45rem',
    overflowY: 'scroll',
  },
  checkArea: {
    height: '3rem',
    border: '0.0625rem solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 0.375rem 0.375rem',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    '& input+label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOff}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input:checked + label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOn}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input': {
      height: '1.25rem',
      width: '1.25rem',
      marginRight: '0.375rem !important',
      display: 'none',
    },
  },
  errorIcon: {
    width: '0.75rem',
    height: '0.75rem',
    color: '#ff3723',
    marginRight: '0.1875rem',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0.5rem',
  },
  input: {
    fontSize: theme.font.size14,
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
});

const Input = withStyles(styles)((props) => {
  const {
    classes,
    placeholder,
    register,
    label,
    required1,
    required,
    errors,
    errMsg,
    value,
    disabled,
  } = props;

  return (
    <Fragment>
      <label for={label} hidden>
        {label}
      </label>
      <input
        id={label}
        {...register(label, required)}
        placeholder={placeholder}
        className={[classes.error, classes.input].join(' ')}
        value={value}
        disabled={disabled}
      />
      {errors[label] && <ErrorMsg text={[errors[label].message]} />}
    </Fragment>
  );
});
const ErrorMsg = withStyles(styles)((props) => {
  const { classes, text } = props;
  return (
    <Fragment>
      <div className={classes.errorText}>
        <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
        {text}
      </div>
    </Fragment>
  );
});
const SearchByReserveNumModal = withStyles(styles)((props) => {
  const { classes, modalClose, data, setCloseDialogOpen } = props;
  const [username, setUsername] = useState('');
  const [rcptNo, setRcptNo] = useState('');
  const context = useContext(DataContext);
  const [termText, setTermText] = useState('');
  const [termModalOpen, setTermModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  const handleCheckClick = () => {
    setChecked((prev) => !prev);
    // dispatch()
  };
  const activeEnter = (e) => {
    if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
      handleCheckClick();
    }
  };

  const dispatch = () => {
    console.log('dispathch....');
    var input = document.querySelector('input[name="checkHidden"]');
    const event = new Event('input', { bubbles: true });
    const tracker = input._valueTracker;
    if (tracker) {
      tracker.setValue('');
    }
    input.dispatchEvent(event);
  };
  useEffect(() => {
    (async () => {
      let response = await fetch('/ext/reservation/html/terms/terms_3_kr.html');
      let term_text = await response.text();
      setTermText(term_text);
    })();
  }, []);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setFocus,
  } = useForm();

  const handleUsernameChange = (event) => {
    const tempUsername = event.target.value;
    setUsername(tempUsername);
  };

  const handleRcptNoChange = (event) => {
    const tempRcptNo = event.target.value;
    setRcptNo(tempRcptNo);
  };

  const handleClickConfirm = () => {
    console.log('handleClickConfirm');
    let dataParameters = data?.parameters;
    let dataExpect = data?.expect || {
      mode: 'bypass',
      intent: 'THQ_BOOK_CHECK',
    };
    context.request(
      context,
      dataParameters?.speech || '확인',
      'button',
      {
        ...dataParameters,
        bypass_br: 'search_regist_num',
        user_name: username,
        rcptNo,
      },
      dataExpect
    );
    modalClose();
  };

  const termsRef = useRef();
  const onError = async (errors, e) => {
    console.log('on error!! errors: ', errors);
    console.log('on error!! e: ', e);

    if (errors.user_name) {
      setTimeout(() => {
        setFocus(e.target[0].name);
      }, 300);
    } else if (errors.rcpt_no) {
      setTimeout(() => {
        setFocus(e.target[1].name);
      }, 300);
    } else if (errors.terms) {
      setTimeout(() => {
        termsRef.current.focus();
      }, 300);
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit(handleClickConfirm, onError)}>
        <Grid container className={classes.modalGridContainer}>
          {/* 이름 */}
          <Grid
            item
            xs={12}
            className={[classes.modalGridItemLabel, classes.modalGridItemLabelFirst].join(
              ' '
            )}
          >
            <div className={classes.modalLabel}>
              이름<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                label="user_name"
                register={register}
                errors={errors}
                required={{
                  required: '이름을 입력해주세요.',
                  minLength: { value: 1, message: '이름을 입력해주세요.' },
                  maxLength: { value: 25, message: '최대 입력 길이를 초과하였습니다.' },
                  pattern: {
                    value: /^[ㄱ-ㅎ가-힣a-zA-Z|]+$/gi,
                    message: '이름은 한글, 영문만 가능합니다.',
                  },
                  onChange: handleUsernameChange,
                }}
                value={username}
                placeholder="이름을 입력해주세요."
              />
            </div>
          </Grid>
          {/* 접수번호 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>
              접수번호<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                label="rcpt_no"
                register={register}
                errors={errors}
                required={{
                  required: '접수번호를 입력해주세요.',
                  minLength: { value: 1, message: '접수번호를 입력해주세요.' },
                  maxLength: { value: 20, message: '최대 입력 길이를 초과하였습니다.' },
                  onChange: handleRcptNoChange,
                }}
                placeholder="접수번호를 입력해주세요."
              />
            </div>
          </Grid>
          {/* 개인정보 수집 및 이용동의 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={[classes.modalLabel, classes.terms].join(' ')}>
              <div>
                개인정보 수집 및 이용동의<span className="star">*</span>
              </div>
              <button
                className={classes.showAll}
                onClick={() => {
                  setTermModalOpen(true);

                  const rootChild = document.getElementById('modal');
                  const focusableElements = rootChild.querySelectorAll('*');

                  for (let i = 0; i < focusableElements.length; i++) {
                    focusableElements[i].setAttribute('aria-hidden', 'true');
                  }
                }}
              >
                전문보기
              </button>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={[classes.modalField, classes.textareaField].join(' ')}>
              <div className={classes.termTextArea}>
                <div
                  className={classes.termTextContent}
                  dangerouslySetInnerHTML={{ __html: termText }}
                />
              </div>
              <input
                type="hidden"
                value={checked}
                {...register('terms', { validate: () => checked })}
                name="checkHidden"
              />
              <div className={classes.checkArea}>
                <input
                  id="term_check"
                  type="checkbox"
                  checked={checked}
                  onClick={handleCheckClick}
                />
                <label
                  for="term_check"
                  role="checkbox"
                  aria-checked={checked}
                  tabindex="0"
                  onKeyDown={(e) => activeEnter(e)}
                  aria-label={
                    errors.terms
                      ? '먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.'
                      : null
                  }
                  name="terms"
                  ref={termsRef}
                >
                  {' '}
                  동의합니다.
                </label>
              </div>
            </div>
            {errors.terms && (
              <div className={classes.errorText}>
                <img src={Error} className={classes.errorIcon} alt="체크 필요" />
                먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.
              </div>
            )}
          </Grid>
        </Grid>
        {/* footer button */}
        <Grid container className={classes.modalFooter} spacing={1}>
          <Grid item xs={6} className={classes.modalButtonLeft}>
            <button
              type="button"
              className={classes.modalButton}
              onClick={() => setCloseDialogOpen(true)}
            >
              취소
            </button>
          </Grid>
          <Grid item xs={6} className={classes.modalButtonRight}>
            <button
              className={[classes.modalButton, classes.modalButtonStrong].join(' ')}
            >
              확인
            </button>
          </Grid>
        </Grid>
      </form>
      <Terms3
        modalOpen={termModalOpen}
        modalClose={() => {
          setTermModalOpen(false);
          const rootChild = document.getElementById('modal');
          const focusableElements = rootChild.querySelectorAll('*');

          for (let i = 0; i < focusableElements.length; i++) {
            focusableElements[i].removeAttribute('aria-hidden');
          }
        }}
        checkOk={(ok) => {
          setChecked(ok);
        }}
      />
    </Fragment>
  );
});

function SearchByReserveNum(props) {
  const { classes, data, modalOpen, modalClose } = props;
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const close = () => {
    modalClose();
    setCloseDialogOpen(false);
  };
  return createPortal(
    <div className={classes.root}>
      {/* <Drawer
        anchor="bottom"
        open={modalOpen}
        onClose={() => setCloseDialogOpen(true)}
        classes={{ paper: classes.drawerFrame }}
      > */}
      {modalOpen && (
        <div className={classes.drawerFrame}>
          <div className={classes.drawerRoot}>
            <div className={classes.drawerHeaderClose}>
              <div className={classes.closeContainer}>
                <div className={classes.titleClose} ref={modalRef} tabIndex="0">
                  접수번호 조회
                </div>
                <button className={classes.close}>
                  <img
                    src={Close}
                    className={classes.arrowDown}
                    onClick={() => setCloseDialogOpen(true)}
                    alt="닫기"
                  />
                </button>
              </div>
              <Divider classes={{ root: classes.dividerTitle }} />
            </div>
            <div className={classes.componentWrapper}>
              <SearchByReserveNumModal
                data={data}
                modalOpen={modalOpen}
                modalClose={modalClose}
                setCloseDialogOpen={setCloseDialogOpen}
              />
            </div>
          </div>
        </div>
      )}
      {/* </Drawer> */}
      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        classes={{ paper: classes.dialogRoot }}
      >
        <DialogContent classes={{ root: classes.dialogContent }}>
          지금 종료하시면 입력하신 <br />
          정보가 사라져요. 그만하시겠어요?
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogFooter }}>
          <button type="button" className={classes.dialogFooterBtnLeft} onClick={close}>
            그만하기
          </button>
          <button
            type="button"
            className={classes.dialogFooterBtnRight}
            onClick={() => setCloseDialogOpen(false)}
            autoFocus
          >
            계속하기
          </button>
        </DialogActions>
      </Dialog>
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(SearchByReserveNum);
